export let hres37uColumns = () => {
  let indexColumns = [{
    key: 'codempid',
    name: '',
    labelCodapp: 'HRES37UC1',
    labelIndex: '40',
    class: 'align-center',
    style: 'min-width: 100px;'
  }, {
    key: 'desc_codempid',
    name: '',
    labelCodapp: 'HRES37UC1',
    labelIndex: '50',
    style: 'min-width: 200px;'
  }, {
    key: 'dtereq',
    name: '',
    labelCodapp: 'HRES37UC1',
    labelIndex: '30',
    class: 'align-center',
    style: 'min-width: 120px;',
    dataType: 'date'
  }, {
    key: 'numseq',
    name: '',
    labelCodapp: 'HRES37UC1',
    labelIndex: '20',
    class: 'align-center',
    style: 'min-width: 100px;'
  }, {
    key: 'typcer',
    name: '',
    labelCodapp: 'HRES37UC1',
    labelIndex: '110',
    style: 'min-width: 200px;'
  }, {
    key: 'status',
    name: '',
    labelCodapp: 'HRES37UC2',
    labelIndex: '60',
    style: 'min-width: 200px;'
  }, {
    key: 'desc_codappr',
    name: '',
    labelCodapp: 'HRES37UC1',
    labelIndex: '70',
    style: 'min-width: 200px;'
  }, {
    key: 'dteappr',
    name: '',
    labelCodapp: 'HRES37UC1',
    labelIndex: '80',
    class: 'align-center',
    style: 'min-width: 120px;',
    dataType: 'date'
  }, {
    key: 'remark',
    name: '',
    labelCodapp: 'HRES37UC1',
    labelIndex: '90',
    style: 'min-width: 200px;'
  }, {
    key: 'desc_codempap',
    name: '',
    labelCodapp: 'HRES37UC1',
    labelIndex: '100',
    style: 'min-width: 200px;'
  }]

  return {
    en: {
      index: indexColumns
    },
    th: {
      index: indexColumns
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/columns/hres37u.js